const recipesList = [
  {
    id: 1,
    title: "Buffalo Style Chicken Wings",
    url: "https://living.redmond.com/blogs/recipes/buffalo-style-chicken-wings",
    tags: ["entree", "sides", "appetizers", "salads", "snacks", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/Buffallo_Chicken_200DPI.png?v=1649172846&width=500",
  },
  {
    id: 2,
    title: "Lemon Pepper Chicken Wings",
    url: "https://living.redmond.com/blogs/recipes/lemon-pepper-chicken-wings",
    tags: ["entree", "sides", "appetizers", "salads", "snacks", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/Lemon_Pepper_200DPI.png?v=1649172741&width=500",
  },
  {
    id: 3,
    title: "Chipotle Spinach Artichoke Dip",
    url: "https://living.redmond.com/blogs/recipes/chipotle-spinach-artichoke-dip",
    tags: ["sides", "appetizers", "salads", "snacks", "vegetarian", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/Spinich_Artichoke_Dip_200DPI.png?v=1649173181&width=500",
  },
  {
    id: 4,
    title: "Game Day Party Recipes",
    url: "https://living.redmond.com/blogs/recipes/game-day-party-recipes",
    tags: ["food_inspirations", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/Game_Day_Party_Snacks_200DPI.png?v=1649173816&width=500",
  },
  {
    id: 5,
    title: "Whole Smoked Chicken with Lemon Butter",
    url: "https://living.redmond.com/blogs/recipes/whole-smoked-chicken-with-lemon-butter",
    tags: ["entree", "for_the_grill", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/Smoked_Chicken_200DPI.png?v=1649172915&width=500",
  },
  {
    id: 6,
    title: "How to Brine a Turkey: An Easy, Step-By-Step Recipe",
    url: "https://living.redmond.com/blogs/recipes/how-to-brine-a-turkey-an-easy-step-by-step-recipe",
    tags: ["entree", "keto_friendly", "food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/turkey-brine-blog-post.jpg?v=1649106541&width=500",
  },
  {
    id: 7,
    title:
      "5 Tips to Transform Those Turkey Bones into Tasty, Beneficial Broth",
    url: "https://living.redmond.com/blogs/recipes/5-tips-to-transform-those-turkey-bones-into-tasty-beneficial-broth",
    tags: [
      "entree",
      "beverages",
      "soups",
      "keto_friendly",
      "food_inspirations",
    ],
    img: "https://living.redmond.com/cdn/shop/articles/Turkey-Broth-Blogpost.webp?v=1649300516&width=500",
  },
  {
    id: 8,
    title: "Creamy Coconut Eggnog",
    url: "https://living.redmond.com/blogs/recipes/creamy-coconut-eggnog",
    tags: ["beverages"],
    img: "https://living.redmond.com/cdn/shop/articles/AdobeStock_395735218.jpg?v=1649168924&width=500",
  },
  {
    id: 9,
    title:
      "2 Slider Recipes That'll Make Your Super Bowl Sunday So Much Better",
    url: "https://living.redmond.com/blogs/recipes/2-slider-recipes-that-ll-make-your-super-bowl-sunday-so-much-better",
    tags: ["entree", "sides", "appetizers", "salads", "snacks", "game"],
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Superbowl.webp?v=1792772318&width=500",
  },
  {
    id: 10,
    title: "Shrimp Pesto Pasta",
    url: "https://living.redmond.com/blogs/recipes/shrimp-pesto-pasta",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/v_day_Blogpost_cover_photo-1.jpg?v=1649168577&width=500",
  },
  {
    id: 11,
    title: "Smoked Caprese Salad Recipe",
    url: "https://living.redmond.com/blogs/recipes/smoked-caprese-salad-recipe",
    tags: ["sides", "appetizers", "salads", "snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Smoked-Salt-68_200DPI.jpg?v=1649172953&width=500",
  },
  {
    id: 12,
    title: "Smoky Beet Hummus",
    url: "https://living.redmond.com/blogs/recipes/smoky-beet-hummus",
    tags: ["snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Smoked-Salt-55-1.jpg?v=1649167672&width=500",
  },
  {
    id: 13,
    title: "Smoked Dill Deviled Eggs Recipe",
    url: "https://living.redmond.com/blogs/recipes/smoked-dill-deviled-eggs-recipe",
    tags: ["sides", "appetizers", "salads", "vegetarian", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/Smoked-Salt-55.jpg?v=1649167915&width=500",
  },
  {
    id: 14,
    title: "3 Smoky Recipes That Don't Require a Smoker!",
    url: "https://living.redmond.com/blogs/recipes/3-smoky-recipes-that-dont-require-a-smoker",
    tags: ["food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/3-smoky-recipes.jpg?v=1649168291&width=500",
  },
  {
    id: 15,
    title: "How to Make Your Own Electrolyte Drink",
    url: "https://living.redmond.com/blogs/recipes/how-to-make-your-own-electrolyte-drink",
    tags: ["beverages", "vegetarian", "food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/How-to-Make-Your-Own-Electrolyte-Drink.jpg?v=1657642514&width=500",
  },
  {
    id: 16,
    title: "Sparkling Berry Spritzer",
    url: "https://living.redmond.com/blogs/recipes/sparkling-berry-spritzer",
    tags: ["beverages", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Sparkling-Berry-Spritzer.jpg?v=1649169336&width=500",
  },
  {
    id: 17,
    title: "Re-Lyte Limeade",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-limeade",
    tags: ["beverages", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Re-Lyte-Limeade-Main_Image.jpg?v=1659457427&width=500",
  },
  {
    id: 18,
    title: "Creamy Mango Popsicle Recipe",
    url: "https://living.redmond.com/blogs/recipes/creamy-mango-popsicle-recipe",
    tags: ["desserts", "snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Mango-Popsicle-Main-Image.jpg?v=1659460035&width=1200",
  },
  {
    id: 19,
    title: "Watermelon Lime Re-Lyte Slushie",
    url: "https://living.redmond.com/blogs/recipes/watermelon-lime-re-lyte-slushie",
    tags: ["desserts", "beverages", "snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Watermelon-Lime-Re-Lyte-Slushie_Main_Image.jpg?v=1659460457&width=500",
  },
  {
    id: 20,
    title: "Mini Berry Re-Lyte Popsicles",
    url: "https://living.redmond.com/blogs/recipes/mini-berry-re-lyte-popsicles",
    tags: ["beverages", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Little-Berry-Popsicle-Recipe-Main-Image.jpg?v=1659460796&width=500",
  },
  {
    id: 21,
    title: "Re-Lyte Piña Smoothie",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-pina-colada-recipe",
    tags: ["beverages", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Re-Lyte-Pina-Colada_Main.jpg?v=1659461237&width=500",
  },
  {
    id: 22,
    title: "How to Make Your Own Chicken Stock in an Instant Pot",
    url: "https://living.redmond.com/blogs/recipes/how-to-make-your-own-chicken-stock-in-an-instant-pot",
    tags: ["soups", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/1_1.jpg?v=1664821761&width=500",
  },
  {
    id: 23,
    title: "Smoked Salt Bloody Mary",
    url: "https://living.redmond.com/blogs/recipes/smoked-salt-bloody-mary",
    tags: ["beverages"],
    img: "https://living.redmond.com/cdn/shop/articles/Smoked_Salt_Bloody_Mary_Main_Image.jpg?v=1666021390&width=500",
  },
  {
    id: 24,
    title: "Grilled Salmon with Maple Cherry Pecan Sauce",
    url: "https://living.redmond.com/blogs/recipes/grilled-salmon-with-maple-cherry-pecan-sauce",
    tags: ["entree", "for_the_grill"],
    img: "https://living.redmond.com/cdn/shop/articles/Recipe_Blog_Photos.jpg?v=1666022217&width=500",
  },
  {
    id: 25,
    title: "Three Cheese Queso Dip",
    url: "https://living.redmond.com/blogs/recipes/three-cheese-queso-dip",
    tags: [
      "sides",
      "appetizers",
      "salads",
      "snacks",
      "vegetarian",
      "keto_friendly",
      "game"
    ],
    img: "https://living.redmond.com/cdn/shop/articles/Three_Cheese_Queso_Dip_977ffc73-41d9-4936-8649-542453576018.jpg?&width=500",
  },
  {
    id: 26,
    title: "Buttermilk BBQ Chicken Tenders",
    url: "https://living.redmond.com/blogs/recipes/buttermilk-bbq-chicken-tenders",
    tags: ["entree", "sides", "appetizers", "salads", "snacks"],
    img: "https://living.redmond.com/cdn/shop/articles/3.jpg?v=1666828805&width=500",
  },
  {
    id: 27,
    title: "Baked Cauliflower Steaks with Lemon Yogurt Sauce",
    url: "https://living.redmond.com/blogs/recipes/baked-cauliflower-steaks-with-lemon-yogurt-sauce",
    tags: [
      "entree",
      "sides",
      "appetizers",
      "salads",
      "vegetarian",
      "keto_friendly",
    ],
    img: "https://living.redmond.com/cdn/shop/articles/1_3.jpg?v=1666829664&width=500",
  },
  {
    id: 28,
    title: "Chili Lime Chicken Burger",
    url: "https://living.redmond.com/blogs/recipes/chili-lime-chicken-burger",
    tags: ["entree", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/2_1.jpg?v=1666893008&width=500",
  },
  {
    id: 29,
    title: "Chicken and Butternut Squash Curry",
    url: "https://living.redmond.com/blogs/recipes/chicken-and-butternut-squash-curry",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/Copy_of_Blog_Photos_1.jpg?v=1666897731&width=500",
  },
  {
    id: 30,
    title: "Redmond Life's Favorite Fall Recipes",
    url: "https://living.redmond.com/blogs/recipes/redmond-life-s-favorite-fall-recipes",
    tags: ["food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/1_2.jpg?v=1666829262&width=500",
  },
  {
    id: 31,
    title: "4 Delicious Ways to Use the New Real Salt Organic Seasonings",
    url: "https://living.redmond.com/blogs/recipes/4-delicious-ways-to-use-the-new-real-salt-organic-seasonings",
    tags: ["food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/1_4.jpg?v=1666830353&width=500",
  },
  {
    id: 32,
    title: "Simple Adrenal Cocktail",
    url: "https://living.redmond.com/blogs/recipes/simple-adrenal-cocktail",
    tags: ["beverages", "vegetarian", "food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/2_1_856ab1ae-ce56-47cb-9c5f-d5283650da34.jpg?v=1667491567&width=500",
  },
  {
    id: 33,
    title: "Bacon and Chive Cheesy Orzo",
    url: "https://living.redmond.com/blogs/recipes/bacon-and-chive-cheesy-orzo",
    tags: ["sides", "appetizers", "salads"],
    img: "https://living.redmond.com/cdn/shop/articles/1_44573a18-26ae-46d0-84ff-452c6332b060.jpg?v=1668724509&width=500",
  },
  {
    id: 34,
    title: "Tomato Soup Recipe",
    url: "https://living.redmond.com/blogs/recipes/tomato-soup-recipe",
    tags: ["soups", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/1_2_2c7289d5-3b51-4321-9ebb-51aeb1d8354d.jpg?v=1740075938&width=500",
  },
  {
    id: 35,
    title: "3 Easy Recipes to Elevate Your Next Dinner Party",
    url: "https://living.redmond.com/blogs/recipes/3-easy-recipes-to-elevate-your-next-dinner-party",
    tags: ["food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/Main_Image_b2d67ec5-b5f5-4152-b791-90a313f24767.jpg?v=1668783623&width=500",
  },
  {
    id: 36,
    title: "Poached Egg Avocado Boats",
    url: "https://living.redmond.com/blogs/recipes/poached-egg-avocado-boats",
    tags: [
      "sides",
      "appetizers",
      "salads",
      "breakfast",
      "snacks",
      "vegetarian",
      "keto_friendly",
    ],
    img: "https://living.redmond.com/cdn/shop/articles/Copy_of_Blog_Photos_4.jpg?v=1671740270&width=500",
  },
  {
    id: 37,
    title: "Re-lyte Immunity Gummies",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-immunity-gummies",
    tags: ["desserts", "snacks"],
    img: "https://living.redmond.com/cdn/shop/articles/Re-Lyte_Immunity_Gummies.jpg?v=1668782401&width=500",
  },
  {
    id: 38,
    title: "Baked Salmon Sushi Cups",
    url: "https://living.redmond.com/blogs/recipes/baked-salmon-sushi-cups",
    tags: ["entree", "sides", "appetizers", "salads"],
    img: "https://living.redmond.com/cdn/shop/articles/2_1_8eb1cce0-82e3-4f7c-85f3-fb498bdb912f.jpg?v=1675437438&width=500",
  },
  {
    id: 39,
    title: "Grilled Apricots With Ice Cream",
    url: "https://living.redmond.com/blogs/recipes/grilled-apricots-with-ice-cream-recipe",
    tags: ["desserts"],
    img: "https://living.redmond.com/cdn/shop/articles/Grilled_Apricots_with_Ice_Cream.jpg?v=1678385946&width=500",
  },
  {
    id: 40,
    title: "Cranberry Pecan Cheese Balls",
    url: "https://living.redmond.com/blogs/recipes/cranberry-pecan-cheese-balls",
    tags: ["sides", "appetizers", "salads", "snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/4_1_a8a0a4d7-8603-4dd0-8e15-523ef3db056c.jpg?v=1678812715&width=500",
  },
  {
    id: 41,
    title: "Chef Shawn's Chili Recipe",
    url: "https://living.redmond.com/blogs/recipes/chef-shawns-chili-recipe",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/1_2_a65c20e2-ff9d-4c3d-acb1-cb6ecaacfbfd.jpg?v=1679349189&width=500",
  },
  {
    id: 42,
    title: "Panko Crusted Pork Tenderloin with Apple Walnut Chutney",
    url: "https://living.redmond.com/blogs/recipes/panko-crusted-pork-tenderloin-with-apple-walnut-chutney",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/1_3_1b9329a1-a2a3-483c-811e-472cb558de05.jpg?v=1689278285&width=500",
  },
  {
    id: 43,
    title: "Chicken Nachos",
    url: "https://living.redmond.com/blogs/recipes/chicken-nachos",
    tags: ["entree", "sides", "appetizers", "salads", "snacks", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/3_f3f1c9ea-b36c-47fa-9ca9-95b6f3801ea7.jpg?v=1681839569&width=500",
  },
  {
    id: 44,
    title: "Triple Berry Crisp",
    url: "https://living.redmond.com/blogs/recipes/triple-berry-crisp",
    tags: ["desserts"],
    img: "https://living.redmond.com/cdn/shop/articles/1_6f4d2ff3-c524-4edf-9f50-871c88a17725.jpg?v=1689024497&width=500",
  },
  {
    id: 45,
    title: "7 Delicious Foil-Pack Meals to Cook On a Campfire or Grill",
    url: "https://living.redmond.com/blogs/recipes/7-delicious-foil-pack-meals-to-cook-on-a-campfire-or-grill",
    tags: ["entree", "for_the_grill", "food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/2_1_9b400e44-2cef-4c1e-a0ce-8d2be4a6f431.jpg?v=1689631193&width=500",
  },
  {
    id: 46,
    title: "Grilled Carrots With Seasoned Ricotta Cheese and Pesto",
    url: "https://living.redmond.com/blogs/recipes/grilled-carrots-with-seasoned-ricotta-cheese-and-pesto",
    tags: ["sides", "appetizers", "salads", "for_the_grill"],
    img: "https://living.redmond.com/cdn/shop/articles/1_14.jpg?v=1689279377&width=500",
  },
  {
    id: 47,
    title: "Grilled Salmon BLT",
    url: "https://living.redmond.com/blogs/recipes/grilled-salmon-blt",
    tags: ["entree", "for_the_grill"],
    img: "https://living.redmond.com/cdn/shop/articles/1_17.jpg?v=1690820747&width=500",
  },
  {
    id: 48,
    title: "Prosciutto-Wrapped Watermelon with Queso Fresco and Pine Nuts",
    url: "https://living.redmond.com/blogs/recipes/prosciutto-wrapped-watermelon-with-queso-fresco-and-pine-nuts",
    tags: ["sides", "appetizers", "salads", "for_the_grill"],
    img: "https://living.redmond.com/cdn/shop/articles/2_22.jpg?v=1691183943&width=500",
  },
  {
    id: 49,
    title: "Egg Nachos",
    url: "https://living.redmond.com/blogs/recipes/egg-nachos",
    tags: ["entree", "sides", "appetizers", "salads", "breakfast", "snacks"],
    img: "https://living.redmond.com/cdn/shop/articles/1_19.jpg?v=1691428109&width=500",
  },
  {
    id: 50,
    title: "Re-Lyte Piña Colada Fruit Salad",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-pina-colada-fruit-salad",
    tags: ["sides", "appetizers", "salads", "desserts", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Re-Lyte_Pina_Colada_Fruit_Salad.jpg?v=1692302918&width=500",
  },
  {
    id: 51,
    title: "Re-Lyte Strawberry Salsa",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-strawberry-salsa",
    tags: ["sides", "appetizers", "salads", "snacks", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Re-Lyte_Strawberry_Salsa.jpg?v=1692303047&width=500",
  },
  {
    id: 52,
    title: "Creamy Pesto Chicken",
    url: "https://living.redmond.com/blogs/recipes/creamy-pesto-chicken",
    tags: ["entree", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/Creamy_Pesto_Chicken_RL.jpg?v=1692975756&width=500",
  },
  {
    id: 53,
    title: "Chilaquiles with Fried Egg",
    url: "https://living.redmond.com/blogs/recipes/chilaquiles-with-fried-egg",
    tags: ["entree", "breakfast"],
    img: "https://living.redmond.com/cdn/shop/articles/Chilaquiles_with_Fried_Egg.jpg?v=1694799333&width=500",
  },
  {
    id: 54,
    title: "Chilean Pumpkin Soup",
    url: "https://living.redmond.com/blogs/recipes/chilean-pumpkin-soup",
    tags: ["soups"],
    img: "https://living.redmond.com/cdn/shop/articles/Chilean_Pumpkin_Soup.jpg?v=1696438080&width=500",
  },
  {
    id: 55,
    title: "Pumpkin Spice French Toast",
    url: "https://living.redmond.com/blogs/recipes/pumpkin-spice-french-toast",
    tags: ["breakfast", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Pumpkin_Spice_French_Toast.jpg?v=1698117791&width=500",
  },
  {
    id: 56,
    title: "Re-Lyte Immunity Orange Julius",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-immunity-orange-julius",
    tags: ["beverages", "vegetarian"],
    img: "https://living.redmond.com/cdn/shop/articles/Orange_Julius.jpg?v=1698199683&width=500",
  },
  {
    id: 57,
    title: "How to Brine Meat With the Real Salt Brine Kit",
    url: "https://living.redmond.com/blogs/recipes/how-to-brine-meat-with-the-real-salt-brine-kit",
    tags: ["entree", "keto_friendly", "food_inspirations"],
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Brine_Kit.jpg?v=1703865196&width=500",
  },
  {
    id: 58,
    title: "Farro and Sausage Stuffed Acorn Squash",
    url: "https://living.redmond.com/blogs/recipes/farro-and-sausage-stuffed-acorn-squash",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/Farro_and_Sausage_Stuffed_Acorn_Squash_RL.jpg?v=1698701717&width=500",
  },
  {
    id: 59,
    title: "Sweet Potato and Apple Soup",
    url: "https://living.redmond.com/blogs/recipes/sweet-potato-and-apple-soup",
    tags: ["soups"],
    img: "https://living.redmond.com/cdn/shop/articles/Sweet_Potato_and_Apple_Soup.jpg?v=1699408292&width=1200",
  },
  {
    id: 60,
    title: "2 Festive Cocktails for a Hydrating Holiday",
    url: "https://living.redmond.com/blogs/recipes/2-festive-cocktails-for-a-hydrating-holiday",
    tags: ["food_inspirations"],
    img: "https://living.redmond.com/cdn/shop/articles/2_Festive_Cocktails_for_a_Hydrating_Holiday.jpg?v=1701722536&width=500",
  },
  {
    id: 61,
    title: "Lemon Pepper Salmon with Avocado Pico",
    url: "https://living.redmond.com/blogs/recipes/lemon-pepper-salmon-with-avocado-pico",
    tags: ["entree", "keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/Lemon_Pepper_Salmon.jpg?v=1703703863&width=500",
  },
  {
    id: 62,
    title: "Protein Brownie Cookies",
    url: "https://living.redmond.com/blogs/recipes/protein-brownie-cookies",
    tags: ["desserts", "snacks"],
    img: "https://living.redmond.com/cdn/shop/articles/Protein_Brownie_Cookies.jpg?v=1707146143&width=500",
  },
  {
    id: 63,
    title: "Chile Lime Carne Asada Burrito Bowl",
    url: "https://living.redmond.com/blogs/recipes/chile-lime-carne-asada-burrito-bowl",
    tags: ["entree", "for_the_grill"],
    img: "https://living.redmond.com/cdn/shop/articles/Chile_Lime_Carne_Asada.jpg?v=1705513408&width=500",
  },
  {
    id: 64,
    title: "Raw Walnut Fudge",
    url: "https://living.redmond.com/blogs/recipes/raw-walnut-fudge",
    tags: ["desserts"],
    img: "https://living.redmond.com/cdn/shop/articles/Raw_Walnut_Fudge.jpg?v=1707146660&width=500",
  },
  {
    id: 65,
    title: "Brined Salmon With Dill and Garlic Compound Butter",
    url: "https://living.redmond.com/blogs/recipes/brined-salmon-with-dill-and-garlic-compound-butter",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/Brine_Salmon.jpg?v=1709240804&width=500"
  },
  {
    id: 66,
    title: "Simple Irish Soda Bread",
    url: "https://living.redmond.com/blogs/recipes/simple-irish-soda-bread",
    tags: ["sides"],
    img: "https://living.redmond.com/cdn/shop/articles/Soda_Bread.jpg?v=1707779045&width=500"
  },
  {
    id: 67,
    title: "Loco Moco",
    url: "https://living.redmond.com/blogs/recipes/loco-moco",
    tags: ["breakfast", "entree","keto_friendly"],
    img: "https://living.redmond.com/cdn/shop/articles/Loco_Moco_Blog_520x500.jpg?v=1710371906&width=500"
  },
  {
    id: 68,
    title: "Hot Layered Taco Dip",
    url: "https://living.redmond.com/blogs/recipes/hot-layered-taco-dip",
    tags: ["snacks", "vegetarian", "game"],
    img: "https://living.redmond.com/cdn/shop/articles/Hot_Layered_Taco_Dip_9c8fbd9c-44a7-4ac0-94dc-1fe3d1f63e22.jpg?v=1747159029&width=500"
  },
  {
    id: 69,
    title: "Savory Ground Beef Tacos",
    url: "https://living.redmond.com/blogs/recipes/savory-ground-beef-tacos",
    tags: ["entree"],
    img: "https://living.redmond.com/cdn/shop/articles/Ben_Light_Taco_Recipe_V1_520x500.png?v=1712241519&width=500"
  },
  {
    id: 70,
    title: "Chicken Alfredo",
    url: "https://living.redmond.com/blogs/recipes/chicken-alfredo",
    tags: ["entree"],
    img:"https://living.redmond.com/cdn/shop/articles/Taco_Seasoning_Chicken_Alfredo_with_Monce.jpg?v=1714087488&width=500"
  },
  {
    id: 71,
    title: "Brine Kit Pork Chop",
    url: "https://living.redmond.com/blogs/recipes/brine-kit-pork-chop",
    tags: ["entree", "keto_friendly"],
    img:"https://living.redmond.com/cdn/shop/articles/Pork_Chops.jpg?v=1717166276&width=500"
  },
  {
    id: 72, 
    title: "Smoky Maple Pulled Chicken",
    url: "https://living.redmond.com/blogs/recipes/smoky-maple-pulled-chicken",
    tags: ["entree"],
    img:"https://living.redmond.com/cdn/shop//articles/Pulled_Chicken_520x500.jpg?v=1719416447&width=500"
  },
  {
    id: 73, 
    title: "Strawberry Lemonade Re-Lyte Margarita",
    url: "https://living.redmond.com/blogs/recipes/strawberry-lemonade-re-lyte-margarita",
    tags: ["beverages", "vegetarian"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Strawberry_Margarita.jpg?v=1750447515&width=500"
  },
  {
    id: 74, 
    title: "Lemon Lime Re-Lyte Margarita",
    url: "https://living.redmond.com/blogs/recipes/lemon-lime-re-lyte-margarita",
    tags: ["beverages", "vegetarian"],
    img:"https://living.redmond.com/cdn/shop//articles/Lemon_Lime_Margarita_520x500.jpg?v=1719417402&width=500"
  },
  {
    id: 75, 
    title: "Prickly Rock Steak Tacos",
    url: "https://living.redmond.com/blogs/recipes/prickly-rock-steak-tacos",
    tags: ["entree", "for_the_grill"],
    img:"https://living.redmond.com/cdn/shop//articles/Steak_Tacos_520x500.jpg?v=1721315305&width=500"
  },
  {
    id: 76, 
    title: "Sweet & Salty Protein Balls",
    url: "https://living.redmond.com/blogs/recipes/sweet-salty-protein-balls",
    tags: ["snacks", "vegetarian"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_Salty_Protein_Balls_July_2024_-_DOWNSIZED-14.jpg?v=1764250704&width=500"
  },
  {
    id: 77, 
    title: "Pork Barbacoa",
    url: "https://living.redmond.com/blogs/recipes/pork-barbacoa",
    tags: ["entree"],
    img:"https://living.redmond.com/cdn/shop//articles/Pork_Barbacoa_520x500.jpg?v=1725038232&width=500"
  },
  {
    id: 78, 
    title: "Peaches and Cream Smoothie",
    url: "https://living.redmond.com/blogs/recipes/peaches-and-cream-smoothie",
    tags: ["beverages", "vegetarian","snacks","breakfast"],
    img:"https://living.redmond.com/cdn/shop/articles/Peach_Smoothie_1d38060c-00ec-4c7c-afb5-98d458ab641f.jpg?v=1751466106&width=500"
  },
  {
    id: 79, 
    title: "Monce's Guacamole",
    url: "https://living.redmond.com/blogs/recipes/monces-guacamole",
    tags: ["salads", "sides", "vegetarian","snacks","keto_friendly","food_inspirations"],
    img:"https://living.redmond.com/cdn/shop//articles/Monces_Guacamole_520x500.jpg?v=1726156780&width=500"
  },
  {
    id: 80, 
    title: "Re-Lyte Immunity Shots",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-immunity-shots",
    tags: ["beverages"],
    img:"https://living.redmond.com/cdn/shop//articles/Re-lyte_Immunity_Shots_520x500.jpg?v=1727301750&width=500"
  },
  {
    id: 81, 
    title: "Brined Chicken with Lemon Butter Sauce",
    url: "https://living.redmond.com/blogs/recipes/brined-chicken-with-lemon-butter-sauce",
    tags: ["entree","food_inspirations"],
    img:"https://living.redmond.com/cdn/shop//articles/Brine_Kit_06644652-1bea-4d10-a1d9-690edcd7f819_520x500.jpg?v=1730333078&width=500"
  },
  {
    id: 82, 
    title: "Make Chicken Easy With Real Salt Organic Seasonings",
    url: "https://living.redmond.com/blogs/recipes/make-chicken-easy-with-real-salt-organic-seasonings",
    tags: ["food_inspirations"],
    img:"https://living.redmond.com/cdn/shop//articles/Real_Salt_Seasonings_520x500_520x500_414af645-4122-41ec-af51-5c59070b1328.jpg?v=1738785897&width=500"
  },
  {
    id: 83, 
    title: "Oven-Roasted Shrimp Scampi",
    url: "https://living.redmond.com/blogs/recipes/oven-roasted-shrimp-scampi",
    tags: ["entree","food_inspirations"],
    img:"https://living.redmond.com/cdn/shop//articles/Scampi.jpg?v=1738739464&width=500"
  },
  {
    id: 84, 
    title: "Salty Chocolate Mocktail",
    url: "https://living.redmond.com/blogs/recipes/salty-chocolate-mocktail",
    tags: ["beverages"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Chocolat_Mocktail_c233eb19-095b-4d57-877c-3a38d560a22d.jpg?v=1750446996&width=500"
  },
  {
    id: 85, 
    title: "Cran Apple Lime Mocktail",
    url: "https://living.redmond.com/blogs/recipes/cran-apple-lime-mocktail",
    tags: ["beverages"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Cran_Apple_Lime.jpg?v=1739398750&width=500"
  },
  {
    id: 86, 
    title: "Smoky Bean and Bacon Soup With Kale Pesto",
    url: "https://living.redmond.com/blogs/recipes/smoky-bean-and-bacon-soup-with-kale-pesto",
    tags: ["soups"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Smokey_Bacon.jpg?v=1741192372&width=500"
  },
  {
    id: 87, 
    title: "Smoked Salmon and Goat Cheese Frittata",
    url: "https://living.redmond.com/blogs/recipes/smoked-salmon-and-goat-cheese-frittata",
    tags: ["entree","food_inspirations","keto_friendly"],
    img:"https://living.redmond.com/cdn/shop/articles/prosciutto_frittata_db0f02c9-6155-4912-b3bc-522dfb8b9055.jpg?v=1745960110&width=500"
  },
  {
    id: 88, 
    title: "Lemon Pepper Vinaigrette",
    url: "https://living.redmond.com/blogs/recipes/lemon-pepper-vinaigrette",
    tags: ["salads", "sides"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Lemon_Pepper_Vinaigrette.jpg?v=1745268419&width=500"
  },
  {
    id: 89, 
    title: "Mini Dutch Baby Pancakes With Hazelnut Spread",
    url: "https://living.redmond.com/blogs/recipes/mini-dutch-baby-pancakes-with-hazelnut-spread",
    tags:["vegetarian","breakfast"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/May_Oven_Dutch_Baby.jpg?v=1745955498&width=500"
  },
  {
    id: 90, 
    title: "Prosciutto and Brie Frittata",
    url: "https://living.redmond.com/blogs/recipes/prosciutto-and-brie-frittata",
    tags:["entree","breakfast"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Prosciutto_and_Brie_Frittata.jpg?v=1746635754&width=500"
  },
  {
    id: 91, 
    title: "Kebabs Three Ways: Beef, Chicken, and Veggie",
    url: "https://living.redmond.com/blogs/recipes/kebabs-three-ways-beef-chicken-and-veggie",
    tags:["entree","for_the_grill","vegetarian","game"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Main_Image_1.jpg?v=1751988144&width=500"
  },
  {
    id: 92, 
    title: "Chimichurri Steak Sandwich",
    url: "https://living.redmond.com/blogs/recipes/chimichurri-steak-sandwich",
    tags:["entree","for_the_grill"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Main_Image_-5.jpg?v=1755011303&width=500"
  },
  {
    id: 93, 
    title: "Cottage Cheese Egg Bites",
    url: "https://living.redmond.com/blogs/recipes/cottage-cheese-egg-bites",
    tags:["breakfast","snacks","keto_friendly"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_of_the_Month_September_Egg_Bites_2025-01.jpg?v=1757352319&width=400"
  },
  {
    id: 94, 
    title: "Salted Honey Caramel Popcorn",
    url: "https://living.redmond.com/blogs/recipes/salted-honey-caramel-popcorn",
    tags:["desserts","snacks"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/main_Image-34.jpg?v=1759441755&width=400"
  },
  {
    id: 95, 
    title: "Jesse Itzler’s Real Salt Smoothie",
    url: "https://living.redmond.com/blogs/recipes/jesse-itzler-s-real-salt-smoothie",
    tags:["breakfast","beverages","vegetarian"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/articles/Brown_smoothies_39cd363c-1a69-473f-9a79-422aea1ab7ab.jpg?v=1762273042&width=400"
  },
  {
    id: 96, 
    title: "Sausage and Herb Stuffing",
    url: "https://living.redmond.com/blogs/recipes/sausage-and-herb-stuffing",
    tags:["salads","sides"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/articles/Main_Image-35.jpg?v=1763577156&width=400"
  },
  {
    id: 97, 
    title: "Real Salt Chocolate Chip Cookies",
    url: "https://living.redmond.com/blogs/recipes/real-salt-chocolate-chip-cookies",
    tags:["desserts","snacks"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Main_Image_-8.jpg?v=1765466718&width=400"
  },
  {
    id: 98, 
    title: "Meatballs & Tomato Sauce",
    url: "https://living.redmond.com/blogs/recipes/meatballs-tomato-sauce",
    tags:["entree"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Meatballs_and_tomato_sauce.jpg?v=17706670358&width=400"
  },
  {
    id: 99, 
    title: "Chili Lime Chicken Tortilla Soup",
    url: "https://living.redmond.com/blogs/recipes/chili-lime-chicken-tortilla-soup",
    tags:["entree","soups"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/articles/Chili_Lime_Chicken_Tortilla_Soup_4945f05f-8619-413e-b5ac-64188c415114.jpg?v=1773333079&width=400"
  },
  {
    id: 100, 
    title: "Lemon Blueberry Protein Muffins",
    url: "https://living.redmond.com/blogs/recipes/lemon-blueberry-protein-muffins",
    tags:["desserts","snacks","breakfast"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/articles/Main_Image_-9.jpg?v=1775749682&width=400"
  },
  {
    id: 101, 
    title: "Mediterranean Burgers",
    url: "https://living.redmond.com/blogs/recipes/mediterranean-burgers",
    tags:["for_the_grill","entree"],
    img:"https://cdn.shopify.com/s/files/1/0031/8606/5475/articles/Main_Image_7492326e-e42d-41c5-8118-ff7020698bf4.jpg?v=1783544586&width=400"
  },
  {
    id: 102, 
    title: "Re-Lyte Kids Pineapple Popsicles",
    url: "https://living.redmond.com/blogs/recipes/re-lyte-kids-pineapple-popsicles",
    tags:["snacks","desserts","vegetarian"],
    img:"https://living.redmond.com/cdn/shop/articles/Re-Lyte_Kids_Pineapple_Popsicles_747acdd2-73aa-4633-aef4-e2a35dfa1e84.jpg?v=1786722534&width=400"
  },
  {
    id: 103, 
    title: "Mexican Street Corn",
    url: "https://living.redmond.com/blogs/recipes/mexican-street-corn",
    tags:["for_the_grill","salads", "sides","vegetarian"],
    img:"https://living.redmond.com/cdn/shop/articles/Mexican_Elote_a860011c-80f4-4512-b63e-f7d53cefd74b.jpg?v=1786037577&width=400"
  },
];

const recipeCategories = [
  {
    id: 1,
    title: "Game Day Recipes",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Main_Image_1.jpg?v=1751988144",
    tags: ["game"],
    url: "https://living.redmond.com/pages/recipecategories?page=game-day-recipes",
  },
  {
    id: 2,
    title: "Entrees",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_of_the_Month_July_2025_Shish_Kebabs_-_DOWNSIZED-22.jpg?v=1752605446",
    tags: ["entree"],
    url: "https://living.redmond.com/pages/recipecategories?page=entrees",
  },
  {
    id: 3,
    title: "Sides And Salads",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipes_with_Shawn_Hot_Grill_Summer_Camping_Smoked_Salt_Lemon_Pepper_Garlic_Pepper_Taco_Seasoning_June_16_2023-25.jpg?v=1764253678",
    url: "https://living.redmond.com/pages/recipecategories?page=sides-and-salads",
    tags: ["salads", "sides"],
  },
  {
    id: 4,
    title: "Desserts",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_of_the_Month_Caramel_Popcorn_2025-33.jpg?v=1764250900",
    tags: ["desserts"],
    url: "https://living.redmond.com/pages/recipecategories?page=desserts",
  },
  {
    id: 5,
    title: "Soups",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Smokey_Bacon.jpg?v=1740710605",
    tags: ["soups"],
    url: "https://living.redmond.com/pages/recipecategories?page=soups",
  },
  {
    id: 6,
    title: "Breakfast",
    img: "https://living.redmond.com/cdn/shop/articles/Pumpkin_Spice_French_Toast.jpg?v=1698117791",
    tags: ["breakfast"],
    url: "https://living.redmond.com/pages/recipecategories?page=breakfast",
  },
  {
    id: 7,
    title: "For The Grill",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Second_Image.jpg?v=1755011498",
    tags: ["for_the_grill"],
    url: "https://living.redmond.com/pages/recipecategories?page=for-the-grill",
  },
  {
    id: 8,
    title: "Snacks",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_Salty_Protein_Balls_July_2024_-_DOWNSIZED-14.jpg?v=1764250704",
    tags: ["snacks"],
    url: "https://living.redmond.com/pages/recipecategories?page=snacks",
  },
  {
    id: 9,
    title: "Vegetarian",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Chocolate_635253a2-cd07-4f73-9517-9f3d2fb0c1cd.jpg?v=1745955901",
    tags: ["vegetarian"],
    url: "https://living.redmond.com/pages/recipecategories?page=vegetarian",
  },
  {
    id: 10,
    title: "Keto Friendly",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Recipe_of_the_Month_September_Egg_Bites_2025-01.jpg?v=1757352319",
    tags: ["keto_friendly"],
    url: "https://living.redmond.com/pages/recipecategories?page=keto-friendly",
  },
  {
    id: 11,
    title: "Beverages",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/Prickly_Rock_Fiesta_Tacos_and_Watermelon_Margarita_April_2024_-_DOWNSIZED-5.jpg?v=1764253095",
    tags: ["beverages"],
    url: "https://living.redmond.com/pages/recipecategories?page=beverages",
  },
  {
    id: 12,
    title: "Food Inspirations",
    img: "https://cdn.shopify.com/s/files/1/0031/8606/5475/files/prosciutto_frittata.jpg?v=1743578705",
    tags: ["food_inspirations"],
    url: "https://living.redmond.com/pages/recipecategories?page=food-inspirations",
  },
];

const getRecipesCategorized = () => {
  return recipeCategories.map((recipeCategory) => ({
    ...recipeCategory,
    recipes: recipesList.filter((recipe) =>
      recipe.tags.some((tag) => recipeCategory.tags.includes(tag))
    ),
  }));
};
